define('viewModels/widgets/dataGridCells/enumFilter',[
    'lib/knockout',
    'lib/lodash4',
    'extensions/i18n/knockout.i18n'
], function (ko, _) {
    'use strict';

    /**
     * Implements an enum filter column header for the data grid.
     * @param filterProperty - {string} The property in the API that you're filtering on.
     * @param enumObject - {Object} An enum object from src/js/enums
     * @param localizationPrefix - {string} The prefix to append to the property name from enumObject for the en-US
     * string.
     * @param mapValueFunc - {function} (Optional) A function that takes the enum value and lets you customize it
     * before tossing it on the filter
     * @constructor
     */
    var EnumFilter = function (filterProperty, enumObject, localizationPrefix, mapValueFunc) {
        var self = this;

        self.template = 'templates/widgets/dataGridCells/filters/enumFilter';

        var allOption = {
            enumValue: '<ALL>',
            enumText: ko.i18n.renderString('dataGridCells.enumFilter.all')
        };
        var selectedEnum = ko.observable(allOption);

        /**
         * Builds up a select options object based off the enum, sorts it, and adds
         * the <All> option.
         */
        var buildOptions = function() {
            var options = [];
            _.forEach(_.keys(enumObject), function(enumKey) {
                options.push({
                    enumValue: enumObject[enumKey],
                    enumText: ko.i18n.renderString(localizationPrefix + enumKey)
                });
            });
            options = _.sortBy(options, 'enumText');
            options.unshift(allOption);
            return options;
        };

        self.viewModel = {
            id: 'enumFilter-' + filterProperty,
            options: buildOptions(),
            selectedEnum: selectedEnum
        };

        self.filterProperty = filterProperty;

        self.isFilterSet = function() {
            return selectedEnum() !== allOption;
        };

        self.filterValue = ko.computed(
            function(){
                if(self.isFilterSet()) {
                    if (_.isFunction(mapValueFunc)) {
                        return mapValueFunc(selectedEnum().enumValue);
                    }

                    return selectedEnum().enumValue;
                }

                return null;
            });
    };

    return EnumFilter;
});

